import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';

export const GridView: FC<BaseSvgProps> = ({
  'data-testid': dataTestId,
  width = '12',
  primaryColorHexCode,
}) => (
  <svg
    data-testid={dataTestId}
    width={width}
    height={width}
    className="shrink-0"
    viewBox="0 0 7 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0H3V3.5H0V0ZM4 0H7V3.5H4V0ZM0 4.5H3V8H0V4.5ZM4 4.5H7V8H4V4.5Z"
      fill={primaryColorHexCode ?? 'currentColor'}
    />
  </svg>
);
